// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordsLoader_container__3TPO1"};